import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  colors,
  MenuItem,
  Link,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  isFilledNewReport,
  isUpdateEditReport
} from 'src/context/constantMethod';
import { setAlertMessage } from 'src/actions/alertAction';
import { confirmMessage } from 'src/constantsMessage';
import { useLocation } from 'react-router';
import getProductType from 'src/components/ProductType';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1),
    backgroundColor: colors.red[600]
  },
  popover: {
    width: 250
  },
  item: {
    display: 'flex',
    justifyContent: 'center'
  }
}));

function Account() {
  const classes = useStyles();
  const ref = useRef(null);
  const account = useSelector(state => state.account);
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    initialObjectRedux,
    bankListRedux,
    filesRedux,
    deletedStatementsRedux,
    deletedAccountListRedux,
    deletedLimitIdsRedux,
    reportDetailsRedux,
    deletedGstStatementsRedux,
    gstFilesRedux,
    gstListRedux
  } = useSelector(state => state.report);
  const [isOpen, setOpen] = useState(false);

  const productType = getProductType();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrevent = (e, href) => {
    if (location.pathname.includes('createReport')) {
      if (
        isFilledNewReport(
          initialObjectRedux.stateObject,
          bankListRedux,
          filesRedux
        )
      ) {
        e.preventDefault();
        dispatch(
          setAlertMessage(confirmMessage.navigateReport, 'error', href, true)
        );
      }
    }
    if (location.pathname.includes('analysis')) {
      if (
        isUpdateEditReport(
          initialObjectRedux.stateObject,
          bankListRedux,
          gstListRedux,
          filesRedux,
          reportDetailsRedux.reportAccounts,
          reportDetailsRedux.reportGst,
          deletedStatementsRedux,
          deletedAccountListRedux,
          deletedLimitIdsRedux,
          reportDetailsRedux,
          deletedGstStatementsRedux,
          gstFilesRedux
        )
      ) {
        e.preventDefault();
        dispatch(
          setAlertMessage(confirmMessage.navigateReport, 'error', href, true)
        );
      }
    }
  };

  if (!account.user) {
    return null;
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar
          alt="User"
          className={classes.avatar}
          src={account.user.avatar}
        />
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {`${account.user.user.firstName || ''} ${account.user.user
              .lastName || ''}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem onClick={handleClose} className={classes.item}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography color="textSecondary">
              {account.user.user.email || ''}
            </Typography>
            <Typography color="textSecondary">
              {account.user.user.roles[0].roleName || ''}
            </Typography>
            <Link
              component={RouterLink}
              to={`/${productType.toLowerCase()}/changePassword`}
              onClick={e =>
                handlePrevent(e, `/${productType.toLowerCase()}/changePassword`)
              }
            >
              Change password
            </Link>
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
